"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrGeneralMediaGalleryItem = exports.FdrSingleMediaGalleryItem = exports.FdrThumbnailItemMedia = exports.FdrThumbnailItem = exports.FdrThumbnails = exports.FdrSwipeIcon = exports.FdrSlideInfo = exports.FdrMediaGalleryPreviewModal = exports.FdrMediaGalleryBody = exports.FdrMediaGalleryWrapper = exports.FdrGalleryPreviewIcon = exports.FdrOpenPreviewButton = exports.FdrRightChevron = exports.FdrLeftChevron = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const core_basis_bs_icon_1 = require("@hotelplan/core.basis.bs-icon");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const fdr_media_gallery_media_item_1 = require("./fdr-media-gallery-media-item");
const Chevron = (0, styled_components_1.default)(core_basis_bs_icon_1.BsIcon)((0, util_theme_sxc_1.sx2CssThemeFn)({ variant: 'icons.lg' }), (0, util_theme_sxc_1.sx2CssThemeFn)({
    cursor: 'pointer',
    width: '45px',
    height: '30px',
    color: 'white',
    display: ['none', 'block'],
    variant: 'dropShadow',
    filter: 'drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.7))',
}), ({ enable }) => enable
    ? {
        display: 'block',
    }
    : {});
exports.FdrLeftChevron = (0, styled_components_1.default)(Chevron).attrs({
    testId: 'slide-to-left',
    className: 'left-chevron',
})({});
exports.FdrRightChevron = (0, styled_components_1.default)(Chevron).attrs({
    testId: 'slide-to-right',
    className: 'right-chevron',
})({});
exports.FdrOpenPreviewButton = styled_components_1.default.button.attrs({
    'data-id': `open-preview-button`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    variant: 'buttons.iconBtn',
    backgroundColor: 'transparent',
    m: 3,
}));
exports.FdrGalleryPreviewIcon = (0, styled_components_1.default)(core_basis_bs_icon_1.BsIcon)((0, util_theme_sxc_1.sx2CssThemeFn)({
    variant: ['icons.md', `icons.lg`],
    filter: 'drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.7))',
}));
const mediaGalleryWrapperCss = ({ theme }) => (0, util_theme_sxc_1.sx2CssTheme)(theme, {
    '.slider-slide': {
        width: '100%',
    },
    '.image': {
        height: '100%',
        width: '100%',
        objectFit: `cover`,
        objectPosition: `bottom`,
        borderRadius: '3px 3px 0 0',
    },
    '.slider, .slider-slide': {
        ':focus': {
            outline: 'none',
        },
    },
});
const mediaGalleryWrapperPreviewCss = ({ theme }) => {
    var _a;
    return (0, util_theme_sxc_1.sx2CssTheme)(theme, {
        height: '100%',
        '.slider-slide': {
            textAlign: 'center',
            width: '100%',
            '.image': {
                maxWidth: ['100%', '85%'],
                width: '100%',
                objectFit: `cover`,
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translateY(-50%) translateX(-50%)',
            },
        },
        '.right-chevron, .left-chevron': {
            color: 'black',
            variant: 'icons.lg',
        },
        '.slider-control-centerleft': {
            left: '25px!important',
        },
        '.slider-control-centerright': {
            right: '25px!important',
        },
        '.slide-info': {
            maxWidth: '970px',
        },
        '.slider, .slider-slide': {
            ':focus': {
                outline: 'none',
            },
        },
    }, (_a = theme.mediaGallery) === null || _a === void 0 ? void 0 : _a.mediaGalleryWrapperPreviewCss);
};
exports.FdrMediaGalleryWrapper = styled_components_1.default.div(props => (0, util_theme_sxc_1.sx2CssThemeFn)(props.preview ? mediaGalleryWrapperPreviewCss : mediaGalleryWrapperCss));
exports.FdrMediaGalleryBody = styled_components_1.default.div({
    position: 'relative',
});
exports.FdrMediaGalleryPreviewModal = (0, styled_components_1.default)(components_common_modals_1.WhiteBoxModal).attrs({
    name: 'galleryPreview',
    fullScreen: true,
})(({ theme }) => theme.mediaGallery.mediaGalleryModal);
exports.FdrSlideInfo = styled_components_1.default.div(({ theme }) => {
    var _a;
    return (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({ display: 'flex', mx: [3, 'auto'], color: 'secondary', paddingTop: [2, 3], fontSize: [1, 2], '.slide-title': {}, '.slide-number': {
            px: [0, 4],
            ml: 'auto',
            flex: '0 0 auto',
        } }, (((_a = theme.mediaGallery) === null || _a === void 0 ? void 0 : _a.slideInfo) || {})));
});
exports.FdrSwipeIcon = (0, styled_components_1.default)(core_basis_bs_icon_1.BsIcon).attrs({
    name: 'swipe',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: ['inline-block', 'inline-block', 'none'],
    zIndex: 2,
    height: '50px',
    width: '50px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
}));
exports.FdrThumbnails = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    maxWidth: '1145px',
    width: '100%',
    mx: ['-3px', 'auto'],
    pt: ['27px', 4],
    flexWrap: 'wrap',
}), ({ theme }) => { var _a; return (_a = theme.mediaGallery) === null || _a === void 0 ? void 0 : _a.thumbnails; });
exports.FdrThumbnailItem = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    width: [`${100 / 3}%`, 'auto'],
    px: ['3px', 0],
    '&:not(:last-child)': {
        mr: [0, '10px'],
    },
    '.thumbnail-button': {
        fontSize: '0px',
        mb: ['6px', 0],
    },
}), ({ theme }) => { var _a; return (_a = theme.mediaGallery) === null || _a === void 0 ? void 0 : _a.thumbnailsItem; });
exports.FdrThumbnailItemMedia = (0, styled_components_1.default)(fdr_media_gallery_media_item_1.MediaGalleryItem).attrs({
    isThumbnail: true,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    width: ['100%', '105px'],
    height: '80px',
    objectFit: `cover`,
}));
exports.FdrSingleMediaGalleryItem = (0, styled_components_1.default)(fdr_media_gallery_media_item_1.MediaGalleryItem)(({ height }) => ({
    height,
}));
exports.FdrGeneralMediaGalleryItem = (0, styled_components_1.default)(fdr_media_gallery_media_item_1.MediaGalleryItem)({
    height: '100%',
});
//# sourceMappingURL=fdr-media-gallery.styles.js.map